/**
 * @generated SignedSource<<523eb54ec43439cd78f1ed9696627574>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutUIActionsTransactionSetup_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_transaction" | "checkoutUIReducer_transaction">;
  readonly " $fragmentType": "checkoutUIActionsTransactionSetup_transaction";
};
export type checkoutUIActionsTransactionSetup_transaction$key = {
  readonly " $data"?: checkoutUIActionsTransactionSetup_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIActionsTransactionSetup_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutUIActionsTransactionSetup_transaction"
};

(node as any).hash = "cb0649f74f05ef939fcb134a57fb94ac";

export default node;
